import Layout from "@/layouts";
/**
 * icon
 * home: 首页
 * alarm: 报警
 * car: 车辆
 * company: 公司
 * complaint: 投诉
 * sys: 系统
 * order: 订单
 *
 * hide: true, // 是否隐藏
 *
 */

export default [
  {
    path: "/",
    component: () => import("@/view/login"),
  },
  {
    path: "/home",
    component: Layout,
    children: [
      {
        path: "/home",
        component: () => import("@/view/home"),
        meta: {
          title: "首页",
          icon: "home",
          menuId: 1,
        },
      },
    ],
  },
  {
    path: "/404",
    component: Layout,
    children: [
      {
        path: "/404",
        component: () => import("@/view/404.vue"),
        meta: {
          title: "404",
          icon: "home",
          hide: true,
        },
      },
    ],
  },
  {
    path: "/company",
    component: Layout,
    children: [
      {
        path: "/company",
        component: () => import("@/view/company"),
        meta: {
          title: "公司管理",
          icon: "company",
          menuId: 2,
        },
      },
    ],
  },
  {
    path: "/car",
    component: Layout,
    children: [
      {
        path: "/car-manage",
        component: () => import("@/view/car-manage"),
        meta: {
          title: "车辆管理",
          icon: "car",
          menuId: 3,
        },
      },
      {
        path: "/car-detail",
        component: () => import("@/view/car-manage/detail"),
        meta: {
          title: "车辆详情",
          icon: "car",
          hide: true,
          menuId: 31,
        },
      },
      {
        path: "/car-playback",
        component: () => import("@/view/playback"),
        meta: {
          title: "车辆回放",
          hide: true,
        },
      },
    ],
  },
  {
    path: "/early-warning",
    component: Layout,
    children: [
      {
        path: "/early-warning",
        component: () => import("@/view/early-warning"),
        meta: {
          title: "报警记录",
          icon: "alarm",
          menuId: 9,
        },
      },
    ],
  },
  {
    path: "/order",
    component: Layout,
    children: [
      {
        path: "/order",
        component: () => import("@/view/order"),
        meta: {
          title: "订单记录",
          icon: "order",
          menuId: 6,
        },
      },
    ],
  },
  // {
  //   path: "/complaint",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "/complaint",
  //       component: () => import("@/view/complaint/index"),
  //       meta: {
  //         title: "投诉记录",
  //         icon: "complaint",
  //         menuId: 12,
  //       },
  //     },
  //   ],
  // },
  {
    path: "/systemManage",
    meta: {
      title: "系统管理",
      icon: "sys",
    },
    component: Layout,
    children: [
      {
        path: "driver",
        component: () => import("@/view/systemManage/driver"),
        meta: {
          title: "驾驶员列表",
          menuId: 4,
        },
      },
      {
        path: "type",
        component: () => import("@/view/car-type"),
        meta: {
          title: "车辆分类",
          menuId: 5,
        },
      },
      {
        path: "user",
        component: () => import("@/view/systemManage/user"),
        meta: {
          title: "用户管理",
          menuId: 15,
        },
      },
      {
        path: "role",
        component: () => import("@/view/systemManage/role"),
        meta: {
          title: "角色管理",
          menuId: 22,
        },
      },
      {
        path: "add-role",
        component: () => import("@/view/systemManage/role/addEdit.vue"),
        meta: {
          title: "添加角色",
          hide: true,
          menuId: 24,
        },
      },
      {
        path: "role-detail",
        component: () => import("@/view/systemManage/role/detail"),
        meta: {
          title: "角色详情",
          hide: true,
          menuId: 27,
        },
      },
    ],
  },
];
